/**
 * Tiny in-memory logger for the master agent + dispatcher.
 *
 * Disabled by default; enable via `localStorage.coachAgentDebug = 'on'`
 * to surface routed intents in the browser console while debugging.
 * Phase F may extend this with structured fixtures for tests.
 */

import type { RouterIntent } from './types';

interface LogEntry {
  ts: number;
  text: string;
  source: 'router' | 'regex' | 'pending';
  intent: RouterIntent | null;
  routedTo: string;
}

const buffer: LogEntry[] = [];
const MAX_BUFFER = 50;

export function isRouterDebugEnabled(): boolean {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage.getItem('coachAgentDebug') === 'on';
    }
  } catch {
    // ignore
  }
  return false;
}

export function logRouted(entry: Omit<LogEntry, 'ts'>): void {
  const full: LogEntry = { ...entry, ts: Date.now() };
  buffer.push(full);
  if (buffer.length > MAX_BUFFER) buffer.shift();
  if (isRouterDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.info('[CoachSteve router]', full);
  }
}

export function getRouterLog(): readonly LogEntry[] {
  return buffer.slice();
}
